<!--  /**
     * 轨迹完整分析的腾讯地图
     * @jlliang
     */-->
<template>
    <div style="height: 100%;width: 100%">
        <div style="position: absolute;left: 10px;top: 10px;z-index: 9999">
            <van-button size="mini" type="info" z-index="9999" @click="onback">返回</van-button>
        </div>
        <div v-if="show" style="position: absolute;left:50%;top:50%;z-index: 9999">
            <van-loading color="#1989fa" size="40px"/>
        </div>
        <div id="qqmap" v-bind:style="{width:windowwidth+'px',height:windowheight+'px'}"></div>
        <div>
            <Table :height="windowheight2" size="small" :columns="columns1" :data="data1"></Table>
        </div>
        <div>
            <Table :height="windowheight2" size="small" :columns="columns2" :data="data2"></Table>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {GPS} from '@/libs/positonUtils'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Toast).use(Loading);

    export default {
        name: "QQMap",
        data() {
            return {
                show: true,
                windowwidth: '',
                windowheight: '',
                windowheight2: '',
                qqMap: '',

                content: [],
                vehicleMarkers: [],
                shiftTracksList: [],
                discontinuousTracksList: [],

                mapData: {
                    vehicleRunMarkerImage: null,
                    vehicleStopMarkerImage: null,
                    startMarker: null,
                    endMarker: null,
                    polyline: null,
                    discontinuousTracksPolyline: [],
                    shiftTracksPolyline: [],
                    selectMarker: null,
                    infoWin: null
                },


                columns1: [
                    {
                        title: '开始时间',
                        key: 'startDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.startDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '结束时间',
                        key: 'endDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.endDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '里程',
                        key: 'discontinuousTracks',
                        align: 'center',
                        render: (h, params) => {
                            console.log(params.row)
                            console.log(params.row.mileage)
                            let aa = (params.row.mileage) / 10
                            return h('div', aa);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 70,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            if (this.mapData.discontinuousTracksPolyline) {
                                                for (let i = 0; i < this.mapData.discontinuousTracksPolyline.length; i++) {
                                                    if (this.mapData.discontinuousTracksPolyline[i].trackId === params.row.id) {
                                                        if (this.mapData.discontinuousTracksPolyline[i].map == null) {
                                                            this.mapData.discontinuousTracksPolyline[i].setMap(this.qqMap)
                                                        } else {
                                                            this.mapData.discontinuousTracksPolyline[i].setMap(null)
                                                        }
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },'显示'),
                            ]);
                        }
                    }
                ],
                data1: [],
                // data1: [
                //     {
                //         startDatetime: 'John Brown',
                //         age: 18,
                //         address: 'New York No. 1 Lake Park',
                //         date: '2016-10-03'
                //     },
                //     {
                //         startDatetime: 'Jim Green',
                //         age: 24,
                //         address: 'London No. 1 Lake Park',
                //         date: '2016-10-01'
                //     },
                //     {
                //         startDatetime: 'Joe Black',
                //         age: 30,
                //         address: 'Sydney No. 1 Lake Park',
                //         date: '2016-10-02'
                //     },
                //     {
                //         startDatetime: 'Jon Snow',
                //         age: 26,
                //         address: 'Ottawa No. 2 Lake Park',
                //         date: '2016-10-04'
                //     },
                //     {
                //         startDatetime: 'John Brown',
                //         age: 18,
                //         address: 'New York No. 1 Lake Park',
                //         date: '2016-10-03'
                //     },
                //     {
                //         startDatetime: 'Jim Green',
                //         age: 24,
                //         address: 'London No. 1 Lake Park',
                //         date: '2016-10-01'
                //     },
                //     {
                //         startDatetime: 'Joe Black',
                //         age: 30,
                //         address: 'Sydney No. 1 Lake Park',
                //         date: '2016-10-02'
                //     },
                //     {
                //         startDatetime: 'Jon Snow',
                //         age: 26,
                //         address: 'Ottawa No. 2 Lake Park',
                //         date: '2016-10-04'
                //     }
                // ],
                columns2: [
                    {
                        title: '开始时间',
                        key: 'startDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.startDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '结束时间',
                        key: 'endDatetime',
                        align: 'center',
                        render: (h, params) => {
                            let aa = params.row.endDatetime
                            return h('div', new Date(aa).Format('yyyy-MM-dd hh:mm:ss'));
                        }
                    },
                    {
                        title: '里程',
                        key: 'shiftTracksList',
                        align: 'center',
                        render: (h, params) => {
                            console.log(params.row)
                            console.log(params.row.mileage)
                            let aa = (params.row.mileage) / 10
                            return h('div', aa);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 70,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            if (this.mapData.shiftTracksPolyline) {
                                                for (let i = 0; i < this.mapData.shiftTracksPolyline.length; i++) {
                                                    if (this.mapData.shiftTracksPolyline[i].trackId === params.row.id) {
                                                        if (this.mapData.shiftTracksPolyline[i].map == null) {
                                                            this.mapData.shiftTracksPolyline[i].setMap(this.qqMap)
                                                        } else {
                                                            this.mapData.shiftTracksPolyline[i].setMap(null)
                                                        }
                                                        break
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }, '显示'),
                            ]);
                        }
                    }
                ],
                data2: []
            }
        },
        methods: {
            onback() {
                this.$router.push({
                    name: 'tracksintegrityanalysiss'
                })
            },
            mapInit() {
                this.mapDefaultCenter = new qq.maps.LatLng(39.916527, 116.397128)
                this.qqMap = new qq.maps.Map(document.getElementById('qqmap'), {
                    // 地图的中心地理坐标。
                    center: this.mapDefaultCenter
                })
            },
            drawTrack() {

                let startMarkerImage = new qq.maps.MarkerImage('/start.png', null, null, null, new qq.maps.Size(30, 40))
                let endMarkerImage = new qq.maps.MarkerImage('/end.png', null, null, null, new qq.maps.Size(30, 40))
                // if(!this.mapData.vehicleRunMarkerImage) {
                // this.mapData.vehicleRunMarkerImage = new qq.maps.MarkerImage('/vehiclerun.png', new qq.maps.Size(24, 43), new qq.maps.Point(0, 0), new qq.maps.Point(12, 21))
                // }
                // if(!this.mapData.vehicleStopMarkerImage) {
                // this.mapData.vehicleStopMarkerImage = new qq.maps.MarkerImage('/vehiclestop.png', new qq.maps.Size(24, 43), new qq.maps.Point(0, 0), new qq.maps.Point(12, 21))
                // }

                this.mapData.startMarker = new qq.maps.Marker({icon: startMarkerImage})
                this.mapData.endtMarker = new qq.maps.Marker({icon: endMarkerImage})
                // this.mapData.selectMarker = new qq.maps.Marker({icon: this.mapData.vehicleRunMarkerImage})

                let s = null
                let w = null
                let n = null
                let e = null
                let polylines = []
                let length = this.content.length
                let p = null
                for (var i = 0; i < length; i++) {
                    if (i === 0) {
                        let startPos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
                        this.mapData.startMarker.setPosition(new qq.maps.LatLng(startPos.lat, startPos.lon))
                        this.mapData.startMarker.setMap(this.qqMap)

                        let selectPos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
                        let p = new qq.maps.LatLng(selectPos.lat, selectPos.lon)
                        // this.mapData.selectMarker.setPosition(p)
                        // this.mapData.selectMarker.setMap(this.qqMap)
                        // this.mapData.selectMarker.setRotation(this.content[i].direction)
                        if ((this.content[i].state & 0x01) === 0x01) {
                            // this.mapData.selectMarker.setIcon(this.mapData.vehicleRunMarkerImage)
                        } else {
                            // this.mapData.selectMarker.setIcon(this.mapData.vehicleStopMarkerImage)
                        }
                    }

                    if (i === length - 1) {
                        let endPos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
                        this.mapData.endtMarker.setPosition(new qq.maps.LatLng(endPos.lat, endPos.lon))
                        this.mapData.endtMarker.setMap(this.qqMap)
                    }

                    if (n === null) {
                        n = this.content[i].latitude
                    }
                    if (s === null) {
                        s = this.content[i].latitude
                    }
                    if (w === null) {
                        w = this.content[i].longitude
                    }
                    if (e === null) {
                        e = this.content[i].longitude
                    }

                    if (this.content[i].latitude < n) {
                        n = this.content[i].latitude
                    }
                    if (this.content[i].latitude > s) {
                        s = this.content[i].latitude
                    }
                    if (this.content[i].longitude < w) {
                        w = this.content[i].longitude
                    }
                    if (this.content[i].longitude > e) {
                        e = this.content[i].longitude
                    }
                    if (i < length - 1) {
                        // let pos = {lat:this.content[i].latitude, lon:this.content[i].longitude}
                        let pos = GPS.gcj_encrypt(this.content[i].latitude, this.content[i].longitude)
                        polylines.push(new qq.maps.LatLng(pos.lat, pos.lon))
                        // p = new qq.maps.Polyline({path: [new qq.maps.LatLng(this.content[i].latitude, this.content[i].longitude), new qq.maps.LatLng(this.content[i + 1].latitude, this.content[i + 1].longitude)]})
                        // p.setMap(this.qqMap)
                        // polylines.push(p)
                    }
                }
                this.mapData.polyline = new qq.maps.Polyline({path: polylines})
                this.mapData.polyline.setMap(this.qqMap)
                // console.log(polylines)
                console.log('s:' + s + ',w:' + w + ',n:' + n + ',e:' + e)
                this.qqMap.fitBounds(new qq.maps.LatLngBounds(new qq.maps.LatLng(s, w), new qq.maps.LatLng(n, e)))

            },
        },
        mounted() {
            console.log(window.innerWidth)
            console.log(window.innerHeight)
            this.windowwidth = window.innerWidth
            this.windowheight = window.innerHeight * 0.7
            this.windowheight2 = window.innerHeight * 0.15

            this.mapInit()

            if (this.$route.params.item.discontinuousTracksList) {
                this.data1 = JSON.parse(this.$route.params.item.discontinuousTracksList).discontinuousTracksList
            }
            if (this.$route.params.item.shiftTracksList) {
                this.data2 = JSON.parse(this.$route.params.item.shiftTracksList).shiftTracksList
            }

            console.log(this.$route.params.item)
            //全日折线
            store.dispatch('LocateHistoryServ_LoadDailyTrack', {
                params: {
                    terminalNum: this.$route.params.item.terminalNum,
                    selectDatetime: new Date(this.$route.params.item.analyzeDatetime).Format(('yyyy-MM-dd hh:mm:ss')),
                },
                urlparams: null
            }).then((res) => {
                console.log(res)
                if (res.data.length!=0) {
                    this.content = store.getters.get_LocateHistory_LoadDailyTrackResult
                    this.drawTrack()
                }

                // let allpolylinePath = []
                // res.data.forEach(p => {
                //     let pos = GPS.gcj_encrypt(p.latitude, p.longitude)
                //     allpolylinePath.push(new qq.maps.LatLng(pos.lat, pos.lon))
                // })
                // let polyline = new qq.maps.Polyline({strokeColor: '#0000ff', path: allpolylinePath})
                // polyline.setMap(this.qqMap)


                let tracksIntegrityAnalysis = this.$route.params.item
                // 绘制断开轨迹
                this.discontinuousTracksList = []
                let discontinuousTracksList = tracksIntegrityAnalysis.discontinuousTracksList
                if (discontinuousTracksList) {
                    discontinuousTracksList = JSON.parse(discontinuousTracksList)
                    console.log(discontinuousTracksList)
                    this.discontinuousTracksList = discontinuousTracksList.discontinuousTracksList
                    discontinuousTracksList.discontinuousTracksList.forEach(item => {
                        let polylinePath = []
                        item.discontinuousTracks.forEach(p => {
                            let pos = GPS.gcj_encrypt(p.lat, p.lng)
                            polylinePath.push(new qq.maps.LatLng(pos.lat, pos.lon))
                        })
                        let polyline = new qq.maps.Polyline({strokeColor: '#ff0000', path: polylinePath})
                        polyline.setMap(this.qqMap)
                        polyline.trackId = item.id
                        this.mapData.discontinuousTracksPolyline.push(polyline)
                    })
                }

                // 绘制漂移轨迹
                this.shiftTracksList = []
                let shiftTracksList = tracksIntegrityAnalysis.shiftTracksList
                if (shiftTracksList) {
                    shiftTracksList = JSON.parse(shiftTracksList)
                    console.log(shiftTracksList)
                    this.shiftTracksList = shiftTracksList.shiftTracksList
                    shiftTracksList.shiftTracksList.forEach(item => {
                        let polylinePath = []
                        item.shiftTracks.forEach(p => {
                            let pos = GPS.gcj_encrypt(p.lat, p.lng)
                            polylinePath.push(new qq.maps.LatLng(pos.lat, pos.lon))
                        })
                        let polyline = new qq.maps.Polyline({strokeColor: '#CC00cc', path: polylinePath})
                        polyline.setMap(this.qqMap)
                        polyline.trackId = item.id
                        this.mapData.shiftTracksPolyline.push(polyline)
                    })
                }
                this.show = false
            }).catch((err) => {
                console.log(err)
            })
        },
    }
</script>

<style scoped>

</style>
